import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-6 max-w-6xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading text-primary-800 mb-1" }, " Manager Console "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500" }, " Staff dashboard for Foxwood Crossing ")
], -1)
const _hoisted_4 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" }
const _hoisted_5 = { class: "bg-white border border-primary-200 rounded-xl p-4 shadow-soft" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 mb-2\"><div class=\"w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0\"><svg class=\"w-5 h-5 text-green-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><span class=\"text-sm font-medium text-primary-500\">Paid</span></div>", 1)
const _hoisted_7 = { class: "flex items-baseline gap-1" }
const _hoisted_8 = { class: "text-2xl font-bold text-primary-800" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary-500" }, "houses", -1)
const _hoisted_10 = { class: "text-xs text-green-600 mt-1" }
const _hoisted_11 = { class: "bg-white border border-primary-200 rounded-xl p-4 shadow-soft" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 mb-2\"><div class=\"w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0\"><svg class=\"w-5 h-5 text-amber-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><span class=\"text-sm font-medium text-primary-500\">Unpaid</span></div>", 1)
const _hoisted_13 = { class: "flex items-baseline gap-1" }
const _hoisted_14 = { class: "text-2xl font-bold text-primary-800" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary-500" }, "houses", -1)
const _hoisted_16 = { class: "text-xs text-amber-600 mt-1" }
const _hoisted_17 = { class: "bg-white border border-primary-200 rounded-xl p-4 shadow-soft" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 mb-2\"><div class=\"w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0\"><svg class=\"w-5 h-5 text-blue-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6\"></path></svg></div><span class=\"text-sm font-medium text-primary-500\">Claims</span></div>", 1)
const _hoisted_19 = { class: "flex items-baseline gap-1" }
const _hoisted_20 = { class: "text-2xl font-bold text-primary-800" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary-500" }, "pending", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-blue-600 mt-1" }, "Awaiting review", -1)
const _hoisted_23 = { class: "bg-white border border-primary-200 rounded-xl p-4 shadow-soft" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 mb-2\"><div class=\"w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0\"><svg class=\"w-5 h-5 text-purple-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z\"></path></svg></div><span class=\"text-sm font-medium text-primary-500\">Requests</span></div>", 1)
const _hoisted_25 = { class: "flex items-baseline gap-1" }
const _hoisted_26 = { class: "text-2xl font-bold text-primary-800" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-primary-500" }, "assigned", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-purple-600 mt-1" }, "To you", -1)
const _hoisted_29 = { class: "grid lg:grid-cols-3 gap-6" }
const _hoisted_30 = { class: "lg:col-span-2 space-y-6" }
const _hoisted_31 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft overflow-hidden" }
const _hoisted_32 = { class: "flex items-center justify-between px-6 py-4 border-b border-primary-200" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800" }, " Assigned Contact Requests ", -1)
const _hoisted_34 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-purple-100 text-purple-700 rounded-full"
}
const _hoisted_35 = {
  key: 0,
  class: "p-6"
}
const _hoisted_36 = { class: "animate-pulse space-y-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-10 bg-primary-200 rounded-full" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-4 bg-primary-200 rounded w-3/4 mb-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-primary-100 rounded w-1/2" })
], -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "p-12 text-center"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4\"><svg class=\"w-8 h-8 text-primary-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4\"></path></svg></div><h3 class=\"text-lg font-heading font-semibold text-primary-800 mb-2\"> All Caught Up! </h3><p class=\"text-primary-500\"> No contact requests assigned to you at this time. </p>", 3)
const _hoisted_44 = [
  _hoisted_41
]
const _hoisted_45 = {
  key: 2,
  class: "divide-y divide-primary-100"
}
const _hoisted_46 = { class: "flex items-center gap-4 min-w-0" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "min-w-0" }
const _hoisted_50 = { class: "font-medium text-primary-800 truncate" }
const _hoisted_51 = { class: "text-sm text-primary-500 truncate" }
const _hoisted_52 = { class: "flex items-center gap-3 flex-shrink-0" }
const _hoisted_53 = { class: "text-xs text-primary-400" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft overflow-hidden" }
const _hoisted_58 = { class: "flex items-center justify-between px-6 py-4 border-b border-primary-200" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800" }, " Pending Claim Requests ", -1)
const _hoisted_60 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 rounded-full"
}
const _hoisted_61 = {
  key: 0,
  class: "p-6"
}
const _hoisted_62 = { class: "animate-pulse space-y-4" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-10 bg-primary-200 rounded-full" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-4 bg-primary-200 rounded w-3/4 mb-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-primary-100 rounded w-1/2" })
], -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = {
  key: 1,
  class: "p-12 text-center"
}
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<div class=\"w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4\"><svg class=\"w-8 h-8 text-primary-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><h3 class=\"text-lg font-heading font-semibold text-primary-800 mb-2\"> No Pending Claims </h3><p class=\"text-primary-500\"> All house ownership claims have been processed. </p>", 3)
const _hoisted_70 = [
  _hoisted_67
]
const _hoisted_71 = {
  key: 2,
  class: "divide-y divide-primary-100"
}
const _hoisted_72 = { class: "flex items-start justify-between gap-4" }
const _hoisted_73 = { class: "min-w-0" }
const _hoisted_74 = { class: "font-medium text-primary-800" }
const _hoisted_75 = { class: "text-sm text-primary-500" }
const _hoisted_76 = { class: "text-xs text-primary-400 mt-1" }
const _hoisted_77 = { class: "flex items-center gap-2 flex-shrink-0" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "space-y-6" }
const _hoisted_81 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft p-4 overflow-hidden" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800 mb-3" }, " Quick Actions ", -1)
const _hoisted_83 = { class: "space-y-2" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center group-hover:bg-emerald-200 transition-colors" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 text-emerald-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    })
  ])
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-primary-700 group-hover:text-primary-900" }, " Record Check Payment ", -1)
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 text-blue-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
    })
  ])
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-primary-700 group-hover:text-primary-900" }, " Create Vote ", -1)
const _hoisted_89 = ["href"]
const _hoisted_90 = /*#__PURE__*/_createStaticVNode("<div class=\"w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center group-hover:bg-green-200 transition-colors\"><svg class=\"w-4 h-4 text-green-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><div class=\"flex items-center gap-2\"><span class=\"text-sm font-medium text-primary-700 group-hover:text-primary-900\"> Payment Dashboard </span><svg class=\"w-3 h-3 text-primary-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14\"></path></svg></div>", 2)
const _hoisted_92 = [
  _hoisted_90
]
const _hoisted_93 = ["href"]
const _hoisted_94 = /*#__PURE__*/_createStaticVNode("<div class=\"w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center group-hover:bg-purple-200 transition-colors\"><svg class=\"w-4 h-4 text-purple-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6\"></path></svg></div><div class=\"flex items-center gap-2\"><span class=\"text-sm font-medium text-primary-700 group-hover:text-primary-900\"> Manage Houses </span><svg class=\"w-3 h-3 text-primary-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14\"></path></svg></div>", 2)
const _hoisted_96 = [
  _hoisted_94
]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-accent-100 rounded-lg flex items-center justify-center group-hover:bg-accent-200 transition-colors" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 text-accent-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    })
  ])
], -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-primary-700 group-hover:text-primary-900" }, " Manage Events ", -1)
const _hoisted_99 = ["href"]
const _hoisted_100 = /*#__PURE__*/_createStaticVNode("<div class=\"w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center group-hover:bg-primary-200 transition-colors\"><svg class=\"w-4 h-4 text-primary-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 12a3 3 0 11-6 0 3 3 0 016 0z\"></path></svg></div><div class=\"flex items-center gap-2\"><span class=\"text-sm font-medium text-primary-700 group-hover:text-primary-900\"> Django Admin </span><svg class=\"w-3 h-3 text-primary-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14\"></path></svg></div>", 2)
const _hoisted_102 = [
  _hoisted_100
]
const _hoisted_103 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft p-4 overflow-hidden" }
const _hoisted_104 = { class: "text-lg font-heading font-semibold text-primary-800 mb-3" }
const _hoisted_105 = { class: "mb-4" }
const _hoisted_106 = { class: "flex justify-between text-sm mb-2" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-600" }, "Progress", -1)
const _hoisted_108 = { class: "font-medium text-primary-800" }
const _hoisted_109 = { class: "h-3 bg-primary-100 rounded-full overflow-hidden" }
const _hoisted_110 = { class: "grid grid-cols-2 gap-4 text-center" }
const _hoisted_111 = { class: "p-3 bg-green-50 rounded-lg" }
const _hoisted_112 = { class: "text-2xl font-bold text-green-700" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-green-600" }, "Paid", -1)
const _hoisted_114 = { class: "p-3 bg-amber-50 rounded-lg" }
const _hoisted_115 = { class: "text-2xl font-bold text-amber-700" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-amber-600" }, "Unpaid", -1)
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { class: "bg-white rounded-xl shadow-lg max-w-md w-full overflow-hidden" }
const _hoisted_119 = { class: "p-6" }
const _hoisted_120 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_121 = {
  key: 0,
  class: "p-4 bg-green-50 border border-green-200 rounded-lg"
}
const _hoisted_122 = { class: "flex items-center gap-2" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-green-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_124 = { class: "text-green-700 font-medium" }
const _hoisted_125 = {
  key: 1,
  class: "p-4 bg-red-50 border border-red-200 rounded-lg"
}
const _hoisted_126 = { class: "text-red-700" }
const _hoisted_127 = {
  key: 2,
  class: "space-y-3"
}
const _hoisted_128 = { class: "text-primary-700" }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { class: "bg-primary-50 rounded-lg p-4 space-y-2" }
const _hoisted_132 = { class: "flex justify-between" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-sm" }, "Requester:", -1)
const _hoisted_134 = { class: "text-primary-800 font-medium" }
const _hoisted_135 = { class: "flex justify-between" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-sm" }, "Email:", -1)
const _hoisted_137 = { class: "text-primary-800" }
const _hoisted_138 = { class: "flex justify-between" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-sm" }, "House:", -1)
const _hoisted_140 = { class: "text-primary-800 font-medium" }
const _hoisted_141 = {
  key: 0,
  class: "px-6 py-4 bg-primary-50 border-t border-primary-100 flex justify-end gap-3"
}
const _hoisted_142 = ["disabled"]
const _hoisted_143 = ["disabled"]
const _hoisted_144 = { key: 0 }
const _hoisted_145 = { key: 1 }
const _hoisted_146 = ["onClick"]
const _hoisted_147 = { class: "bg-white rounded-xl shadow-lg max-w-lg w-full overflow-hidden max-h-[90vh] flex flex-col" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-4 border-b bg-emerald-50 border-emerald-100 flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-emerald-800" }, " Record Check Payment ")
], -1)
const _hoisted_149 = { class: "p-6 overflow-y-auto flex-grow" }
const _hoisted_150 = {
  key: 0,
  class: "p-4 bg-green-50 border border-green-200 rounded-lg"
}
const _hoisted_151 = { class: "flex items-center gap-2" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-green-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_153 = { class: "text-green-700 font-medium" }
const _hoisted_154 = {
  key: 1,
  class: "p-4 bg-red-50 border border-red-200 rounded-lg mb-4"
}
const _hoisted_155 = { class: "text-red-700" }
const _hoisted_156 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, [
  /*#__PURE__*/_createTextVNode(" House "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_158 = { class: "relative" }
const _hoisted_159 = {
  key: 0,
  class: "absolute z-10 w-full mt-1 bg-white border border-primary-200 rounded-lg shadow-lg max-h-48 overflow-y-auto"
}
const _hoisted_160 = ["onClick"]
const _hoisted_161 = { class: "font-medium text-primary-800" }
const _hoisted_162 = {
  key: 0,
  class: "text-sm text-primary-500 block"
}
const _hoisted_163 = {
  key: 0,
  class: "mt-2 p-3 bg-emerald-50 border border-emerald-200 rounded-lg flex justify-between items-center"
}
const _hoisted_164 = { class: "font-medium text-emerald-800" }
const _hoisted_165 = {
  key: 0,
  class: "text-sm text-emerald-600 block"
}
const _hoisted_166 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_167 = [
  _hoisted_166
]
const _hoisted_168 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, [
  /*#__PURE__*/_createTextVNode(" Amount "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_169 = { class: "relative" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("span", { class: "absolute left-3 top-1/2 -translate-y-1/2 text-primary-500" }, "$", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-primary-500 mt-1" }, "Standard dues: $55.00", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, " Check Number ", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, " Dues Year ", -1)
const _hoisted_174 = ["value"]
const _hoisted_175 = ["value"]
const _hoisted_176 = ["value"]
const _hoisted_177 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, " Check Image ", -1)
const _hoisted_178 = ["onDrop"]
const _hoisted_179 = { key: 0 }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-10 h-10 text-primary-400 mx-auto mb-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary-500" }, "Click or drag image to upload", -1)
const _hoisted_182 = [
  _hoisted_180,
  _hoisted_181
]
const _hoisted_183 = {
  key: 1,
  class: "relative"
}
const _hoisted_184 = ["src"]
const _hoisted_185 = ["onClick"]
const _hoisted_186 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_187 = [
  _hoisted_186
]
const _hoisted_188 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, " Notes ", -1)
const _hoisted_189 = {
  key: 0,
  class: "px-6 py-4 bg-primary-50 border-t border-primary-100 flex justify-end gap-3 flex-shrink-0"
}
const _hoisted_190 = ["disabled"]
const _hoisted_191 = ["disabled"]
const _hoisted_192 = { key: 0 }
const _hoisted_193 = { key: 1 }

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { ManagerApi } from "@/services/ManagerApi";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const auth = useAuthStore();

// State
const loading = ref(true);
const currentYear = new Date().getFullYear();

// Payment stats - replace with API data
const paymentStats = ref({
  paidCount: 0,
  unpaidCount: 0,
  collectedCents: 0,
  outstandingCents: 0,
  collectionPercent: 0,
});

// Assigned contact requests
const assignedRequests = ref<ContactRequestSummary[]>([]);

// Pending claim requests
const pendingClaims = ref<ClaimRequestSummary[]>([]);

// Admin URLs - adjust based on environment
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL?.replace("/api/", "") || "http://localhost:8000";
const adminUrl = computed(() => `${apiBaseUrl}/admin/`);
const adminPaymentUrl = computed(
  () => `${apiBaseUrl}/admin/homes/payment/dashboard/`
);
const adminHousesUrl = computed(() => `${apiBaseUrl}/admin/homes/house/`);

// Helpers
const formatCurrency = (cents: number): string => {
  return (cents / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays} days ago`;

  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const truncateMessage = (message: string, maxLength = 50): string => {
  if (message.length <= maxLength) return message;
  return message.substring(0, maxLength) + "...";
};

const requestTypeClass = (status: string): string => {
  const classes: Record<string, string> = {
    new: "bg-blue-100 text-blue-600",
    open: "bg-purple-100 text-purple-600",
    in_progress: "bg-amber-100 text-amber-600",
    resolved: "bg-green-100 text-green-600",
    closed: "bg-primary-100 text-primary-600",
  };
  return classes[status] || classes.open;
};

// Actions - open in Django admin for now
const viewRequest = (request: ContactRequestSummary) => {
  // Open contact request in Django admin
  window.open(`${apiBaseUrl}/admin/contact_requests/contactrequest/${request.id}/change/`, "_blank");
};

// Claim action state
const claimActionPending = ref(false);
const claimToAction = ref<ClaimRequestSummary | null>(null);
const claimActionType = ref<"approve" | "deny">("approve");
const showClaimModal = ref(false);
const claimActionError = ref("");
const claimActionSuccess = ref("");

const openClaimModal = (claim: ClaimRequestSummary, action: "approve" | "deny") => {
  claimToAction.value = claim;
  claimActionType.value = action;
  claimActionError.value = "";
  claimActionSuccess.value = "";
  showClaimModal.value = true;
};

const closeClaimModal = () => {
  showClaimModal.value = false;
  claimToAction.value = null;
  claimActionError.value = "";
};

const approveClaim = (claim: ClaimRequestSummary) => {
  openClaimModal(claim, "approve");
};

const denyClaim = (claim: ClaimRequestSummary) => {
  openClaimModal(claim, "deny");
};

const confirmClaimAction = async () => {
  if (!claimToAction.value) return;

  claimActionPending.value = true;
  claimActionError.value = "";

  try {
    let response: ClaimActionResponse;
    if (claimActionType.value === "approve") {
      response = await ManagerApi.approveClaim(claimToAction.value.id);
    } else {
      response = await ManagerApi.denyClaim(claimToAction.value.id);
    }

    claimActionSuccess.value = response.message;

    // Remove from the list immediately
    pendingClaims.value = pendingClaims.value.filter(
      (c) => c.id !== claimToAction.value?.id
    );

    // Close modal after brief delay to show success
    setTimeout(() => {
      closeClaimModal();
      claimActionSuccess.value = "";
    }, 1500);
  } catch (error: any) {
    claimActionError.value =
      error.response?.data?.error || "An error occurred. Please try again.";
  } finally {
    claimActionPending.value = false;
  }
};

// Check payment state
const showCheckPaymentModal = ref(false);
const checkPaymentPending = ref(false);
const checkPaymentError = ref("");
const checkPaymentSuccess = ref("");

// Check payment form state
const houseSearch = ref("");
const houseSearchResults = ref<UnpaidHouse[]>([]);
const selectedHouse = ref<UnpaidHouse | null>(null);
const checkAmount = ref<number | null>(55.00);
const checkNumber = ref("");
const checkDuesYear = ref(currentYear);
const checkNotes = ref("");
const checkImage = ref<File | null>(null);
const checkImagePreview = ref<string | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);

let searchTimeout: ReturnType<typeof setTimeout> | null = null;

const openCheckPaymentModal = () => {
  showCheckPaymentModal.value = true;
  resetCheckPaymentForm();
};

const closeCheckPaymentModal = () => {
  showCheckPaymentModal.value = false;
  resetCheckPaymentForm();
};

const resetCheckPaymentForm = () => {
  houseSearch.value = "";
  houseSearchResults.value = [];
  selectedHouse.value = null;
  checkAmount.value = 55.00;
  checkNumber.value = "";
  checkDuesYear.value = currentYear;
  checkNotes.value = "";
  checkImage.value = null;
  checkImagePreview.value = null;
  checkPaymentError.value = "";
  checkPaymentSuccess.value = "";
};

const searchHouses = () => {
  if (searchTimeout) clearTimeout(searchTimeout);

  if (houseSearch.value.length < 2) {
    houseSearchResults.value = [];
    return;
  }

  searchTimeout = setTimeout(async () => {
    try {
      const response = await ManagerApi.fetchUnpaidHouses(checkDuesYear.value, houseSearch.value);
      houseSearchResults.value = response.houses;
    } catch (error) {
      console.error("Failed to search houses:", error);
      houseSearchResults.value = [];
    }
  }, 300);
};

const selectHouse = (house: UnpaidHouse) => {
  selectedHouse.value = house;
  houseSearch.value = house.address;
  houseSearchResults.value = [];
};

const clearSelectedHouse = () => {
  selectedHouse.value = null;
  houseSearch.value = "";
};

const triggerFileInput = () => {
  fileInput.value?.click();
};

const handleFileSelect = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (file) {
    processCheckImage(file);
  }
};

const handleFileDrop = (event: DragEvent) => {
  const file = event.dataTransfer?.files?.[0];
  if (file && file.type.startsWith("image/")) {
    processCheckImage(file);
  }
};

const processCheckImage = (file: File) => {
  checkImage.value = file;
  const reader = new FileReader();
  reader.onload = (e) => {
    checkImagePreview.value = e.target?.result as string;
  };
  reader.readAsDataURL(file);
};

const clearCheckImage = () => {
  checkImage.value = null;
  checkImagePreview.value = null;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
};

const submitCheckPayment = async () => {
  if (!selectedHouse.value || !checkAmount.value) return;

  checkPaymentPending.value = true;
  checkPaymentError.value = "";

  try {
    const response = await ManagerApi.recordCheckPayment({
      house_id: selectedHouse.value.id,
      amount: Math.round(checkAmount.value * 100), // Convert to cents
      check_number: checkNumber.value || undefined,
      dues_year: checkDuesYear.value,
      notes: checkNotes.value || undefined,
      check_image: checkImage.value || undefined,
    });

    checkPaymentSuccess.value = response.message;

    // Refresh dashboard data to update stats
    fetchData();

    // Close modal after brief delay
    setTimeout(() => {
      closeCheckPaymentModal();
    }, 2000);
  } catch (error: any) {
    checkPaymentError.value =
      error.response?.data?.error || "Failed to record payment. Please try again.";
  } finally {
    checkPaymentPending.value = false;
  }
};

// Check staff access and redirect if not authorized
const checkAccess = async () => {
  // Ensure user data is loaded
  if (auth.user_id === -1) {
    await auth.fetch_user_data();
  }
  if (!auth.is_staff) {
    router.push("/community");
    return false;
  }
  return true;
};

// Data fetching
const fetchData = async () => {
  loading.value = true;
  try {
    const dashboardData = await ManagerApi.fetchDashboard();

    // Map payment stats
    const stats = dashboardData.payment_stats;
    const duesAmountCents = 5500; // Could fetch from settings if needed
    paymentStats.value = {
      paidCount: stats.paid_count,
      unpaidCount: stats.unpaid_count,
      collectedCents: stats.total_collected_cents,
      outstandingCents: stats.unpaid_count * duesAmountCents,
      collectionPercent: Math.round(stats.collection_rate),
    };

    // Map assigned contact requests
    assignedRequests.value = dashboardData.my_assignments.contact_requests;

    // Map pending claims
    pendingClaims.value = dashboardData.claim_requests.recent;
  } catch (error) {
    console.error("Failed to fetch manager dashboard data:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  const hasAccess = await checkAccess();
  if (hasAccess) {
    fetchData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(paymentStats.value.paidCount), 1),
            _hoisted_9
          ]),
          _createElementVNode("p", _hoisted_10, " $" + _toDisplayString(formatCurrency(paymentStats.value.collectedCents)) + " collected ", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(paymentStats.value.unpaidCount), 1),
            _hoisted_15
          ]),
          _createElementVNode("p", _hoisted_16, " $" + _toDisplayString(formatCurrency(paymentStats.value.outstandingCents)) + " outstanding ", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(pendingClaims.value.length), 1),
            _hoisted_21
          ]),
          _hoisted_22
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, _toDisplayString(assignedRequests.value.length), 1),
            _hoisted_27
          ]),
          _hoisted_28
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              (assignedRequests.value.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(assignedRequests.value.length) + " open ", 1))
                : _createCommentVNode("", true)
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                      return _createElementVNode("div", {
                        key: i,
                        class: "flex items-center gap-4"
                      }, _hoisted_39)
                    }), 64))
                  ])
                ]))
              : (assignedRequests.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_44))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assignedRequests.value, (request) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: request.id,
                        class: "flex items-center justify-between p-4 hover:bg-primary-50 transition-colors"
                      }, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0", requestTypeClass(request.status)])
                          }, _hoisted_48, 2),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("p", _hoisted_50, _toDisplayString(request.sender), 1),
                            _createElementVNode("p", _hoisted_51, _toDisplayString(truncateMessage(request.message)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(formatDate(request.created_on)), 1),
                          _createElementVNode("button", {
                            class: "text-accent-600 hover:text-accent-700 transition-colors",
                            onClick: ($event: any) => (viewRequest(request))
                          }, _hoisted_56, 8, _hoisted_54)
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              (pendingClaims.value.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(pendingClaims.value.length) + " pending ", 1))
                : _createCommentVNode("", true)
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                      return _createElementVNode("div", {
                        key: i,
                        class: "flex items-center gap-4"
                      }, _hoisted_65)
                    }), 64))
                  ])
                ]))
              : (pendingClaims.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_70))
                : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingClaims.value, (claim) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: claim.id,
                        class: "p-4 hover:bg-primary-50 transition-colors"
                      }, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("p", _hoisted_74, _toDisplayString(claim.requester_name), 1),
                            _createElementVNode("p", _hoisted_75, " Claiming " + _toDisplayString(claim.house_address), 1),
                            _createElementVNode("p", _hoisted_76, " Requested " + _toDisplayString(formatDate(claim.created_at)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (approveClaim(claim)),
                              class: "px-3 py-1.5 text-sm font-medium bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors"
                            }, " Approve ", 8, _hoisted_78),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (denyClaim(claim)),
                              class: "px-3 py-1.5 text-sm font-medium bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
                            }, " Deny ", 8, _hoisted_79)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _hoisted_82,
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("button", {
                onClick: openCheckPaymentModal,
                class: "w-full flex items-center gap-3 p-3 rounded-lg hover:bg-primary-50 transition-colors group text-left"
              }, _hoisted_86),
              _createVNode(_component_router_link, {
                to: "/votes/create",
                class: "flex items-center gap-3 p-3 rounded-lg hover:bg-primary-50 transition-colors group"
              }, {
                default: _withCtx(() => [
                  _hoisted_87,
                  _hoisted_88
                ]),
                _: 1
              }),
              _createElementVNode("a", {
                href: _unref(adminPaymentUrl),
                target: "_blank",
                class: "flex items-center gap-3 p-3 rounded-lg hover:bg-primary-50 transition-colors group"
              }, _hoisted_92, 8, _hoisted_89),
              _createElementVNode("a", {
                href: _unref(adminHousesUrl),
                target: "_blank",
                class: "flex items-center gap-3 p-3 rounded-lg hover:bg-primary-50 transition-colors group"
              }, _hoisted_96, 8, _hoisted_93),
              _createVNode(_component_router_link, {
                to: "/events",
                class: "flex items-center gap-3 p-3 rounded-lg hover:bg-primary-50 transition-colors group"
              }, {
                default: _withCtx(() => [
                  _hoisted_97,
                  _hoisted_98
                ]),
                _: 1
              }),
              _createElementVNode("a", {
                href: _unref(adminUrl),
                target: "_blank",
                class: "flex items-center gap-3 p-3 rounded-lg hover:bg-primary-50 transition-colors group"
              }, _hoisted_102, 8, _hoisted_99)
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("h2", _hoisted_104, _toDisplayString(_unref(currentYear)) + " Dues Collection ", 1),
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _hoisted_107,
                _createElementVNode("span", _hoisted_108, _toDisplayString(paymentStats.value.collectionPercent) + "% ", 1)
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", {
                  class: "h-full bg-accent-500 rounded-full transition-all duration-500",
                  style: _normalizeStyle({ width: paymentStats.value.collectionPercent + '%' })
                }, null, 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("p", _hoisted_112, _toDisplayString(paymentStats.value.paidCount), 1),
                _hoisted_113
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("p", _hoisted_115, _toDisplayString(paymentStats.value.unpaidCount), 1),
                _hoisted_116
              ])
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showClaimModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _withModifiers(closeClaimModal, ["self"])
          }, [
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", {
                class: _normalizeClass(["px-6 py-4 border-b", 
              claimActionType.value === 'approve'
                ? 'bg-green-50 border-green-100'
                : 'bg-red-50 border-red-100'
            ])
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(["text-lg font-heading font-semibold", 
                claimActionType.value === 'approve' ? 'text-green-800' : 'text-red-800'
              ])
                }, _toDisplayString(claimActionType.value === "approve" ? "Approve Claim" : "Deny Claim"), 3)
              ], 2),
              _createElementVNode("div", _hoisted_119, [
                (claimToAction.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                      (claimActionSuccess.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                            _createElementVNode("div", _hoisted_122, [
                              _hoisted_123,
                              _createElementVNode("p", _hoisted_124, _toDisplayString(claimActionSuccess.value), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (claimActionError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                            _createElementVNode("p", _hoisted_126, _toDisplayString(claimActionError.value), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!claimActionSuccess.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                            _createElementVNode("p", _hoisted_128, [
                              (claimActionType.value === 'approve')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_129, " Are you sure you want to approve this claim? This will transfer house ownership to the requester. "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_130, " Are you sure you want to deny this claim? The requester will need to contact the board for more information. "))
                            ]),
                            _createElementVNode("div", _hoisted_131, [
                              _createElementVNode("div", _hoisted_132, [
                                _hoisted_133,
                                _createElementVNode("span", _hoisted_134, _toDisplayString(claimToAction.value.requester_name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_135, [
                                _hoisted_136,
                                _createElementVNode("span", _hoisted_137, _toDisplayString(claimToAction.value.requester_email), 1)
                              ]),
                              _createElementVNode("div", _hoisted_138, [
                                _hoisted_139,
                                _createElementVNode("span", _hoisted_140, _toDisplayString(claimToAction.value.house_address), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!claimActionSuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                    _createElementVNode("button", {
                      onClick: closeClaimModal,
                      class: "px-4 py-2 text-sm font-medium text-primary-700 hover:bg-primary-100 rounded-lg transition-colors",
                      disabled: claimActionPending.value
                    }, " Cancel ", 8, _hoisted_142),
                    _createElementVNode("button", {
                      onClick: confirmClaimAction,
                      class: _normalizeClass(["px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors disabled:opacity-50", 
                claimActionType.value === 'approve'
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-red-600 hover:bg-red-700'
              ]),
                      disabled: claimActionPending.value
                    }, [
                      (claimActionPending.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_144, "Processing..."))
                        : (_openBlock(), _createElementBlock("span", _hoisted_145, _toDisplayString(claimActionType.value === "approve" ? "Approve Claim" : "Deny Claim"), 1))
                    ], 10, _hoisted_143)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_117))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showCheckPaymentModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _withModifiers(closeCheckPaymentModal, ["self"])
          }, [
            _createElementVNode("div", _hoisted_147, [
              _hoisted_148,
              _createElementVNode("div", _hoisted_149, [
                (checkPaymentSuccess.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                      _createElementVNode("div", _hoisted_151, [
                        _hoisted_152,
                        _createElementVNode("p", _hoisted_153, _toDisplayString(checkPaymentSuccess.value), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (checkPaymentError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                      _createElementVNode("p", _hoisted_155, _toDisplayString(checkPaymentError.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!checkPaymentSuccess.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                      _createElementVNode("div", null, [
                        _hoisted_157,
                        _createElementVNode("div", _hoisted_158, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((houseSearch).value = $event)),
                            onInput: searchHouses,
                            type: "text",
                            placeholder: "Search by address or owner...",
                            class: "w-full px-3 py-2 border border-primary-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                          }, null, 544), [
                            [_vModelText, houseSearch.value]
                          ]),
                          (houseSearchResults.value.length > 0 && !selectedHouse.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(houseSearchResults.value, (house) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: house.id,
                                    onClick: ($event: any) => (selectHouse(house)),
                                    class: "w-full px-3 py-2 text-left hover:bg-primary-50 transition-colors"
                                  }, [
                                    _createElementVNode("span", _hoisted_161, _toDisplayString(house.address), 1),
                                    (house.owner)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_162, _toDisplayString(house.owner.name), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_160))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (selectedHouse.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_164, _toDisplayString(selectedHouse.value.address), 1),
                                (selectedHouse.value.owner)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_165, _toDisplayString(selectedHouse.value.owner.name) + " (" + _toDisplayString(selectedHouse.value.owner.email) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("button", {
                                onClick: clearSelectedHouse,
                                class: "text-emerald-600 hover:text-emerald-800"
                              }, _hoisted_167)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_168,
                        _createElementVNode("div", _hoisted_169, [
                          _hoisted_170,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkAmount).value = $event)),
                            type: "number",
                            step: "0.01",
                            min: "0",
                            placeholder: "55.00",
                            class: "w-full pl-7 pr-3 py-2 border border-primary-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                          }, null, 512), [
                            [_vModelText, checkAmount.value]
                          ])
                        ]),
                        _hoisted_171
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_172,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkNumber).value = $event)),
                          type: "text",
                          placeholder: "e.g., 1234",
                          class: "w-full px-3 py-2 border border-primary-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                        }, null, 512), [
                          [_vModelText, checkNumber.value]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_173,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkDuesYear).value = $event)),
                          class: "w-full px-3 py-2 border border-primary-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                        }, [
                          _createElementVNode("option", { value: _unref(currentYear) }, _toDisplayString(_unref(currentYear)), 9, _hoisted_174),
                          _createElementVNode("option", {
                            value: _unref(currentYear) - 1
                          }, _toDisplayString(_unref(currentYear) - 1), 9, _hoisted_175),
                          _createElementVNode("option", {
                            value: _unref(currentYear) - 2
                          }, _toDisplayString(_unref(currentYear) - 2), 9, _hoisted_176)
                        ], 512), [
                          [_vModelSelect, checkDuesYear.value]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_177,
                        _createElementVNode("div", {
                          class: "border-2 border-dashed border-primary-200 rounded-lg p-4 text-center hover:border-emerald-400 transition-colors cursor-pointer",
                          onClick: triggerFileInput,
                          onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: _withModifiers(handleFileDrop, ["prevent"])
                        }, [
                          _createElementVNode("input", {
                            ref_key: "fileInput",
                            ref: fileInput,
                            type: "file",
                            accept: "image/*",
                            class: "hidden",
                            onChange: handleFileSelect
                          }, null, 544),
                          (!checkImagePreview.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_179, _hoisted_182))
                            : (_openBlock(), _createElementBlock("div", _hoisted_183, [
                                _createElementVNode("img", {
                                  src: checkImagePreview.value,
                                  alt: "Check preview",
                                  class: "max-h-32 mx-auto rounded"
                                }, null, 8, _hoisted_184),
                                _createElementVNode("button", {
                                  onClick: _withModifiers(clearCheckImage, ["stop"]),
                                  class: "absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 -mt-2 -mr-2"
                                }, _hoisted_187, 8, _hoisted_185)
                              ]))
                        ], 40, _hoisted_178)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_188,
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checkNotes).value = $event)),
                          rows: "2",
                          placeholder: "Optional notes...",
                          class: "w-full px-3 py-2 border border-primary-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                        }, null, 512), [
                          [_vModelText, checkNotes.value]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!checkPaymentSuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                    _createElementVNode("button", {
                      onClick: closeCheckPaymentModal,
                      class: "px-4 py-2 text-sm font-medium text-primary-700 hover:bg-primary-100 rounded-lg transition-colors",
                      disabled: checkPaymentPending.value
                    }, " Cancel ", 8, _hoisted_190),
                    _createElementVNode("button", {
                      onClick: submitCheckPayment,
                      class: "px-4 py-2 text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 rounded-lg transition-colors disabled:opacity-50",
                      disabled: checkPaymentPending.value || !selectedHouse.value || !checkAmount.value
                    }, [
                      (checkPaymentPending.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_192, "Recording..."))
                        : (_openBlock(), _createElementBlock("span", _hoisted_193, "Record Payment"))
                    ], 8, _hoisted_191)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_146))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})